import { Button } from '@/components/shadcn/button'
import { TooltipButton } from '@/components/ui/TooltipButton'
import { IconEditOutline } from '@icons/IconEditOutline'

interface InlineEditActionsV2Props {
  isInlineEditing: boolean
  isInlineEditEnabled: boolean
  onToggleInlineEdit: () => void
  onSaveInlineEdit: () => void
  onCancelInlineEdit: () => void
  isSubmitting: boolean
  isLoadingFormSchema: boolean
}

export function InlineEditActionsV2({
  isInlineEditing,
  isInlineEditEnabled,
  onToggleInlineEdit,
  onSaveInlineEdit,
  onCancelInlineEdit,
  isSubmitting,
  isLoadingFormSchema,
}: InlineEditActionsV2Props) {
  if (!isInlineEditEnabled) return null

  const editToggleButton = (
    <TooltipButton tooltip="Edit inline">
      <Button
        size="icon"
        variant={isInlineEditing ? 'default' : 'ghost'}
        className="size-8"
        onClick={onToggleInlineEdit}
        disabled={isLoadingFormSchema}
      >
        <IconEditOutline className="size-4" />
      </Button>
    </TooltipButton>
  )

  const saveAndCancelButtons = (
    <>
      <Button size="sm" onClick={onSaveInlineEdit} disabled={isSubmitting}>
        {isSubmitting ? 'Saving...' : 'Save'}
      </Button>
      <Button size="sm" variant="outline" onClick={onCancelInlineEdit} disabled={isSubmitting}>
        Cancel
      </Button>
    </>
  )

  return isInlineEditing ? saveAndCancelButtons : editToggleButton
}
